export default __webpack_public_path__ + "static/media/rewards-icon.206ff424.svg";